import Grid from "@mui/material/Grid";
import MyDatePicker from "../../components/MyDatePicker";
import {useSalesTerritories} from "../../hooks/useSalesTerritories";
import {useSalesRegions} from "../../hooks/useSalesRegions";
import {useState} from "react";
import MySelect from "../../components/MySelect";
import MySearchField from "../../components/MySearchField";
import {useCurrentUser} from "../../hooks/useCurrentUser";
import {useBusinessUnitCodes} from "../../hooks/useBusinessUnitCodes";

const EventsFilter = ({filter, filterChangeFunctions}) => {
    const [salesRegionOptions, setSalesRegionOptions] = useState([]);
    const [salesTerritoryOptions, setSalesTerritoryOptions] = useState([]);
    const [currentUser, _updateCurrentUser] = useCurrentUser(false);
    const [businessUnitCodes, setBusinessUnitCodes] = useState([]);

    useBusinessUnitCodes(true, null, (data) => {
        let options = [...data];
        if (options.length > 1) {
            options = [{id: "", name: "-- CLEAR --"}, ...options];
        }
        if (options.length === 1) {
            filterChangeFunctions.businessUnitCode(options[0].id);
        }
        setBusinessUnitCodes(options);
    });
    useSalesRegions(filter.businessUnitCode, currentUser.id, true, (data) => {
        // Sort by repsCount desc
        data.sort((a, b) => b.repsCount - a.repsCount);
        // Then change name to name (repsCount)
        let updatedData = data.map((item) => ({
            ...item,
            name: `${item.name} (${item.repsCount} ${item.repsCount > 1 ? "reps" : "rep"})`,
        }));
        if (updatedData.length > 0) {
            updatedData = [{id: "", name: "-- CLEAR --"}, ...updatedData];
        }
        setSalesRegionOptions(updatedData);
    });

    useSalesTerritories(filter.businessUnitCode, filter.salesRegion, true, (data) => {
        if (data.length > 0) {
            // let newData = data.map((item) => ({...item, id: item.orgId}));
            let options = [{id: "", name: "-- CLEAR --"}, ...data];
            setSalesTerritoryOptions(options);
        } else {
            setSalesTerritoryOptions(data);
        }
    });
    return (
        <Grid container rowSpacing={0.5} columnSpacing={1}>
            <Grid item sm={6} md={4} lg={3} xl={2.4}>
                <MySearchField
                    label="Search"
                    value={filter.searchString}
                    onChange={filterChangeFunctions.searchString}
                />
            </Grid>
            <Grid item sm={6} md={4} lg={3} xl={2.4}>
                <MyDatePicker
                    label="From Date"
                    variant="outlined"
                    fullWidth
                    value={filter.fromDate}
                    maxDate={filter.toDate || null}
                    onChange={filterChangeFunctions.fromDate}
                    sx={{
                        backgroundColor: "white",
                    }}
                />
            </Grid>
            <Grid item sm={6} md={4} lg={3} xl={2.4}>
                <MyDatePicker
                    label="To Date"
                    variant="outlined"
                    fullWidth
                    value={filter.toDate}
                    minDate={filter.fromDate || null}
                    onChange={filterChangeFunctions.toDate}
                    sx={{
                        backgroundColor: "white",
                    }}
                />
            </Grid>
            <Grid item sm={6} md={4} lg={3} xl={2.4}>
                <MySelect
                    label="Business Unit"
                    options={businessUnitCodes}
                    value={filter.businessUnitCode}
                    onChange={(value) => {
                        filterChangeFunctions.businessUnitCode(value);
                    }}
                    autoSelect={true}
                />
            </Grid>
            <Grid item sm={6} md={4} lg={3} xl={2.4}>
                <MySelect
                    label="Sales Region"
                    options={salesRegionOptions}
                    value={filter.salesRegion}
                    autoSelect={true}
                    onChange={(value) => {
                        filterChangeFunctions.salesRegion(value);
                    }}
                />
            </Grid>
            <Grid item sm={6} md={4} lg={3} xl={2.4}>
                <MySelect
                    label="Sales Territory"
                    options={salesTerritoryOptions}
                    value={filter.salesTerritory}
                    onChange={filterChangeFunctions.salesTerritory}
                />
            </Grid>
        </Grid>
    );
};

export default EventsFilter;
